import { render } from "./PayPer.vue?vue&type=template&id=64bb85d0&scoped=true"
const script = {}

import "./PayPer.vue?vue&type=style&index=0&id=64bb85d0&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bb85d0"]])

export default __exports__